import React from "react";
import "../App.css";

function ViewTrips() {
  return <div>ViewTrips</div>;
}

export default ViewTrips;
